import { useTranslation } from "react-i18next";
import locationIcon from "../../../assets/images/blue-marker.png";
import editIcon from "../../../assets/images/icons/edit_white.svg";
import {
  GeneralButton,
  Loader,
  NoResult,
  SelectLocationOnMap,
} from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import { EditClinicAddressRequest } from "../../../interface/GeneralResponse";
import { TitleWithIcon } from "../../../Share";

function ClinicAddress() {
  const { t } = useTranslation();
  const { data, isPending, isLoading } = useGetData<EditClinicAddressRequest>(
    EndPoints.GetAddress,
  );
  const isNotEditable =
    data?.Data?.City?.Name ||
    data?.Data?.Area?.Name ||
    data?.Data?.Address ||
    data?.Data?.Latitude ||
    data?.Data?.Longitude;
  return (
    <div className="box flex h-full w-full flex-col gap-4 overflow-y-auto">
      <div className="flex items-center justify-between gap-2">
        <p className="font-bold">{t("clinic_address")}</p>
        {isNotEditable && (
          <GeneralButton
            color="yellow"
            icon={editIcon}
            title={t("edit")}
            className="!px-3 !py-2"
            route="/profile/clinic_address/edit"
          />
        )}
      </div>
      {isPending || isLoading ? (
        <Loader />
      ) : isNotEditable ? (
        <>
          <TitleWithIcon
            title={data?.Data?.City?.Name + " " + data?.Data?.Area?.Name}
            icon={locationIcon}
          />
          <TitleWithIcon title={data?.Data?.Address} icon={locationIcon} />
          <SelectLocationOnMap
            ViewOnly
            defaultLocation={{
              lat: data?.Data?.Latitude ?? 33.5138,
              lng: data?.Data?.Longitude ?? 36.2765,
            }}
            className="!h-96"
          />
        </>
      ) : (
        <div className="flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-InputFieldColor py-11">
          <NoResult isWithLogo />
          <GeneralButton
            type="button"
            title={t("add_clinic_address")}
            route="/profile/clinic_address/edit"
          />
        </div>
      )}
    </div>
  );
}

export default ClinicAddress;
